import { useRouteError } from 'react-router-dom';
import UnexpectedError from 'es/app/components/error/UnexpectedError';

export function RouteErrorBoundary() {
    const error = useRouteError();
    if (!(error instanceof Error)) return <UnknownError />;
    if (!error || typeof error !== 'object' || !('stack' in error) || typeof error.stack !== 'string')
        return <UnknownError />;
    return (
        <UnexpectedError
            error={error}
            resetErrorBoundary={() => {
                console.error('Unable to reset error boundary on a route error');
            }}
        />
    );
}

function UnknownError() {
    return (
        <UnexpectedError
            error={new Error('Unknown error')}
            resetErrorBoundary={() => {
                console.error('Unable to reset error boundary on a route error');
            }}
        />
    );
}
